import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsBrandingRoute: InvariantJiraRoute = {
	exact: true,
	name: 'helpcenter-settings-branding',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/branding',
};
